<template>
  <v-card
    outlined
    class="px-6 pt-6 pb-3"
  >
    <div class="d-flex flex-row justify-space-between align-center pb-3 ">
      <label class="subtitle-1 d-block grey--text">{{ title  }}</label>
    </div>

    <v-card-text>
      <v-text-field v-for="(item, i) in  items"
      :key="i"
      :value="item"

      @click:append-outer="removeItem(i)"
      v-model="items[i]"
      :error-messages="head(errorMessages['same_as.'+ i  ])"
      outlined
      append-outer-icon="mdi-trash-can-outline"
    />
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="red lighten-2"
        text
        @click="addItem"
      >
        Add Item
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import head from 'lodash/head'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    add_item_text: {
      type: String,
      default: 'Add Game'
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    }

  },
  methods: {
    head,

    addItem () {
      this.items.push('')
    },

    removeItem (itemIndex) {
      console.log(itemIndex)
      this.items.splice(itemIndex, 1)
    }
  }
}
</script>

<style Scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.list-group {
  width: 100%;
}
</style>
